import { COMPONENT_STATES, COMPONENT_TYPE as TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { generateElementId, generateNodeId } from 'utils/generate-id';
import View from 'client/components/common/BuildingBlocks/Box/Box';
import vars from './Box.scss';

export const BOX_TYPE = {
	FRAME: vars.FRAME as 'FRAME',
	STACK: vars.STACK as 'STACK',
	GRID: vars.GRID as 'GRID',
} as const;

export const BOX = () => {
	const _id = generateElementId();

	return {
		view: View,
		model: {
			_id,
			type: TYPE.BOX,
			uiConfig: {
				layer: undefined,
				editorProps: {
					name: BOX.displayName,
					selectable: true,
					draggable: true,
					expandable: true,
					expanded: true,
				},

				componentProps: {
					styles: {
						[COMPONENT_STATES.DEFAULT]: {
							[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
								// ...
							},
						},
					},
					other: {
						[COMPONENT_STATES.DEFAULT]: {
							[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
								boxType: BOX_TYPE.FRAME,
							},
						},
					},
				},
				nodeProps: {
					id: generateNodeId(_id, BOX.displayName),
				},
			},
			children: [],
		},
	};
};

BOX.displayName = 'Box';
